import { ConfigService } from '../../../services/config.service';

export class EventLocationAdding {
  id: string;
  address: string;
  displayTitle?: string;
  filterByCity?: string;
  isFilterByCity: boolean;
  stateAbbr?: string;
  tags = 'Visitor Posts';
  radius = 1;
  feedId = null;
  categories = [];
  lat = ConfigService.config.google.USCenter.lat;
  lng = ConfigService.config.google.USCenter.lng;
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/edit.account/event.add.location.ts